import * as React from "react";

import { Guest24Filled, Guest24Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const UMSApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "UMSApp" */ "./UMSApp");
    return { default: namedExport.UMSApp };
});

export const UMS: TeamAppConfig = {
    title: "UMS",
    regularIcon: Guest24Regular,
    filledIcon: Guest24Filled,
    description: "The UMS portal let's you access and manage your eligibilities and clearances.",
    team: "IDM",
    publicId: "CONVERGEDPRODUCTIONIDENTITYMPA\\IDM",
    owner: "umshelp@microsoft.com",
    role: "*",
    tags: ["Eligibilities", "clearances", "approvals", "Elevation", "request", "Scenario", "EUPI", "Attestation"],
    app: UMSApp,
    path: "/UMS"
};
